export default __webpack_public_path__ + "static/media/sign-in-background.d9fa9bae.jpg";